/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectCategoryCommand } from '../../models/update-project-category-command';
import { UpdateProjectCategoryCommandResult } from '../../models/update-project-category-command-result';

export interface ApiProjectCategoriesUpdateProjectCategoryPatch$Params {
  
    /**
     * The details of the Project Category to update.
     */
    body?: UpdateProjectCategoryCommand
}

export function apiProjectCategoriesUpdateProjectCategoryPatch(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesUpdateProjectCategoryPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectCategoryCommandResult>;
    })
  );
}

apiProjectCategoriesUpdateProjectCategoryPatch.PATH = '/api/ProjectCategories/UpdateProjectCategory';
